import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomerService } from 'src/app/shared/services/customer-service';
import { SettingsService } from 'src/app/shared/services/settings.service';
import { theme } from '../../../data/theme';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    theme = theme;
    services = [];
    settings = {};

    whatsapp

    constructor(
        public customerService: CustomerService,
        private sanitizer: DomSanitizer,
        public settingsService:SettingsService

    ) {
        this.customerService.list().subscribe(res => {
            let x = res.data
            x.forEach(element => {
                this.services.push({ label: element.Baslik, url: element.Id })
            });
        });


        this.settings = JSON.parse(localStorage.getItem('settings')) || {};
        this.whatsapp = 'https://api.whatsapp.com/send?phone=905303949066';
    }



    sanitize(url: string) {
        window.open(url , '_blank')
    }
}


